// extracted by mini-css-extract-plugin
module.exports = {"ingredientsLine":"ingredients-line_ingredientsLine__2diuD","itemData":"ingredients-line_itemData__2IohB","priceBlock":"ingredients-line_priceBlock__SXrCY"};